module.exports = __webpack_public_path__ + "static/img/bg_empreendimento.373f158.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_empreendimento.jpg
// module id = uRQ+
// module chunks = 0